import { CaseState } from 'app/area/case/types-store';
import { getEntityContext, getComponentData } from 'app/infrastructure/ui/renderer/resolvers';
import { ComponentDescriptor } from 'app/infrastructure/ui/types-uischema';

export const referenceModalTempData = (state: CaseState, uiEngineProps: any) => {

  const componentData = getComponentData(state, { id: 11938 } as ComponentDescriptor, getEntityContext(state, uiEngineProps));

  return {
    fetchingModalOptions: !!componentData?.options.fetching,
    referenceModalOptions: (!componentData?.options.fetching && componentData?.options.data) || []
  };
};
